'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of gastrointestinal
 */ const Gastrointestinal = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3477_3647)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M80.9107 56.02C80.9107 59.8857 77.7786 63.0189 73.9152 63.0189H42.6409C42.1593 63.0189 41.729 63.3597 41.6621 63.8369C41.5796 64.4274 42.0349 64.9321 42.6083 64.9321H62.8642C67.0385 64.9321 70.4225 68.3177 70.4225 72.4941C70.4225 76.6705 67.0385 80.056 62.8642 80.056H59.0697C56.3396 80.056 54.118 82.0035 54.118 84.3967V90.0265C54.118 90.2246 53.9577 90.3851 53.7596 90.3851H46.7239C46.5258 90.3851 46.3655 90.2246 46.3655 90.0265V81.186C46.3655 78.8414 47.2033 76.6226 48.7254 74.9381C50.269 73.2299 52.4572 72.1465 54.8852 71.8908C54.9711 71.8823 55.0248 71.837 55.049 71.8108C55.1014 71.7532 55.1641 71.6287 55.0244 71.4272H36.7891C32.6173 71.4272 29.1863 68.0124 29.3078 63.8407C29.4233 59.8747 32.6723 56.6915 36.6689 56.6915H59.878C60.3582 56.6915 60.7899 56.3507 60.8567 55.8748C60.9405 55.2855 60.4839 54.7783 59.9106 54.7783H30.0318C26.1959 54.7788 23.0862 51.6675 23.0862 47.8298C23.0862 43.9921 26.1959 40.8808 30.0318 40.8808H59.878C60.3582 40.8808 60.7899 40.54 60.8567 40.0642C60.9405 39.4749 60.4839 38.9681 59.9106 38.9681H41.0515C36.9444 38.9681 33.615 35.6372 33.615 31.5281C33.615 27.419 36.9444 24.088 41.0515 24.088H44.9729C47.6819 24.0664 49.878 22.1228 49.878 19.7423V14.1125C49.878 13.9144 50.0384 13.7539 50.2365 13.7539H57.2735C57.4715 13.7539 57.6319 13.9144 57.6319 14.1125V22.8802C57.6319 25.2235 56.7978 27.4351 55.2825 29.1099C53.7469 30.8062 51.5652 31.8824 49.1396 32.1368C48.8159 32.169 48.8515 32.6389 49.1494 32.6389H67.4706C71.4643 32.6389 74.7018 35.878 74.7018 39.8737C74.7018 43.8693 71.4643 47.1084 67.4706 47.1084H36.4345C35.9555 47.1084 35.5252 47.4479 35.457 47.9225C35.3711 48.5131 35.8273 49.0211 36.4023 49.0211H73.9152C77.779 49.0211 80.9107 52.1548 80.9107 56.02Z",
                    fill: theme.ds5.asset[assetColor]["100"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3477_3647",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "57.8246",
                        height: "76.6316",
                        fill: "white",
                        transform: "translate(23.0859 13.7539)"
                    })
                })
            })
        ]
    });
};

exports.Gastrointestinal = Gastrointestinal;
//# sourceMappingURL=Gastrointestinal.cjs.map
